import { useContext, useEffect, useState } from 'react';

import { useLocation } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import RemoveModal from '../../../Components/Modal/RemoveModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { SportContext } from '../Context/SportContext';

const Sport = () => {
  const context = useContext(SportContext);
  const { get, destroy } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getSports();
    };
    getData();
  }, [search]);

  const getSports = async () => {
    setLoading(true);
    await get(
      `/sport${search}`,
      (res) => {
        context.sports = res;
        setLoading(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const removeItem = async (id) => {
    setRemoveLoading(true);

    await destroy(
      `/sport/${id}`,
      (res) => {
        success(`رشته "${modalRemoveObject?.title}" با موفقیت حذف شد.`);
        setRemoveLoading(false);
        setModalIsOpen(false);
        getSports();
      },
      (err) => {
        error('حذف به علت خطا انجام نشد.');
        setRemoveLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar
          title='لیست رشته های'
          createBtnTitle='ایجاد رشته'
          createPath='/sport/create'
        />
        <Datatable
          data={context.sports?.data}
          editUrl='/sport/edit'
          meta={context.sports?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          basePagePath={`/sport`}
          columns={['عنوان']}
          rows={[{ name: 'title', type: 'string' }]}
        />
      </Master>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={removeItem}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف رشته "${modalRemoveObject?.title}" مطمئن هستید ؟`}
      />
    </>
  );
};

export default Sport;
